import { DriveItem } from '@microsoft/microsoft-graph-types';
import { FC } from 'react';
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';
import { isFileFavourite } from '../../utils/favourite';

interface Props {
  file: DriveItem;
}

export const DocumentFavouriteButton: FC<Props> = ({ file }) => {
  const isFavourite = isFileFavourite(file);

  return (
    <div>
      {isFavourite ? <AiFillStar className="h-6 w-6 text-white" /> : undefined}
    </div>
  );
};
